<template>
  <div class="pageContainer">
    <c-page-heading v-if="heading" class="text-decoration-underline">
      {{ heading }}
    </c-page-heading>
    <slot></slot>
  </div>
</template>

<script>
export default { props: { fullHeight: Boolean, heading: String } }
</script>

<style lang="scss" scoped>
.fullHeight {
  height: 100%;
}
</style>
